'use strict';

module.exports = require('./es7-shim').shim();



//////////////////
// WEBPACK FOOTER
// ./node_modules/es7-shim/browser.js
// module id = 776
// module chunks = 0